package com.eladfinish.bible.contest.screens.pairMatching.ui.dialogs

import androidx.compose.foundation.layout.Row
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.tooling.preview.Preview
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.cancel
import com.eladfinish.bible.contest.label_no
import com.eladfinish.bible.contest.ok
import com.eladfinish.bible.contest.ui.common.PreviewTheme
import dev.icerock.moko.resources.compose.stringResource

@Composable
internal fun CopyPairsDialog(
    onDismiss: () -> Unit,
    onConfirmCopyAll: () -> Unit,
    onConfirmCopyOnlyMissing: () -> Unit,
) {
    AlertDialog(
        onDismissRequest = onDismiss,
        title = {
            Text(
                text = "האם להעתיק הכל?",
            )
        },
        text = {
            Text(
                text = """
                    • לחץ 'אישור' כדי להעתיק הכל.
                    • לחץ 'לא' כדי להעתיק רק את הזוגות שלא ידעת להתאים.
                """.trimIndent(),
            )
        },
        confirmButton = {
            TextButton(
                onClick = {
                    onDismiss()
                    onConfirmCopyAll()
                },
            ) {
                Text(text = stringResource(SharedRes.strings.ok))
            }
        },
        dismissButton = {
            Row {
                TextButton(
                    onClick = onDismiss,
                ) {
                    Text(text = stringResource(SharedRes.strings.cancel))
                }

                TextButton(
                    onClick = {
                        onDismiss()
                        onConfirmCopyOnlyMissing()
                    },
                ) {
                    Text(text = stringResource(SharedRes.strings.label_no))
                }
            }
        },
    )
}

@Preview
@Composable
private fun CopyPairsDialogPreview() {
    PreviewTheme {
        CopyPairsDialog(
            onConfirmCopyAll = {},
            onConfirmCopyOnlyMissing = {},
            onDismiss = {},
        )
    }
}
